import React, { useState } from 'react';
import { useSelector } from "react-redux";
import SystemStatusItem from './SystemStatusItem';
import './Overview.scss'
import ChangeDetectedItem from "../../../template/ChangeDetectedItem/ChangeDetectedItem";
// import MyChartComponent from './MyChartComponent';
// import CircularRangeInput from './CircularRangeInput';
import TogglerBody from '../../../template/TogglerBody';
import CircleRangeSlider from './CircleRangeSlider';
import { useChanges } from "../../../../hooks/useChanges";
import { getOverview } from '../../../../store/Overview'
import {overviewApi} from '../../../../http/Api'


const systemStatusArr =[
    {
        name:'Anti-Webhook',
        categories:'Security',
        img:'/img/asside_icon/Anti-WebhookActive.svg',
        link: '',
        keyName: 'anti_webhook',
    },
    {
        name:'Anti-Spam',
        categories:'Moderation',
        img:'/img/asside_icon/Anti-WebhookActive.svg',
        link: '',
        keyName: 'anti_spam',
    },
    {
        name:'Verification',
        categories:'Moderation',
        img:'/img/asside_icon/Anti-WebhookActive.svg',
        link: '',
        keyName: 'verification',
    },
    {
        name:'Anti-Nuke',
        categories:'Security',
        img:'/img/asside_icon/Anti-WebhookActive.svg',
        link: '',
        keyName: 'anti_nuke',
    },
    {
        name:'Fake Detection',
        categories:'Moderation',
        img:'/img/asside_icon/Anti-WebhookActive.svg',
        link: '',
        keyName: 'fake_detection',
    },
    {
        name:'Anti-Raid',
        categories:'Security',
        img:'/img/asside_icon/Anti-WebhookActive.svg',
        link: '',
        keyName: 'anti_raid',
    },
]

const OverviewComponent = ({ eqv, item, overview }) => {
    const { handleSaveChanges, cancelChanges } = useChanges();
    const { changesDetected } = useSelector((state) => state.changeDetected);

    
    const [sliderValue, setSliderValue] = useState(0);

    if (!overview) {
        return null;
    }
    
    return (
        <div className='dashboadr_body_wrap_item overview_component_wrap'>
            <div className='overview_component_content'>
                <div className='overview_component_content_head'>
                    <h4>Server Details and Security</h4>
                    <p>Get a summary of your server's security posture, including details on detected threats, recent moderation actions, and user activity.</p>
                </div>
                <div className='overview_component_content_block'>
                    <div className='overview_component_info-server'>
                        <div className='overview_component_info-server_item overview_component_server_name'>
                            <h3>Server Name</h3>
                            <div className='overview_component_server_name_img-name'>
                                <div className={`server_content_img ${item?.color}`}>
                                    <img src={overview?.avatar} alt="" />
                                    <div className={`info_pay_server ${item?.pay === 'silver' ? 'silver' : ''} ${item?.pay === 'gold' ? 'gold' : ''} ${item?.pay === 'free' ? 'free' : ''}  `}>
                                        <img src="/img/server/infopay.svg" alt="" />
                                    </div>
                                </div>
                                <p className='overview_component_server_name_title'>{overview?.guild_name}</p>
                            </div>
                        </div>
                        <div className='overview_component_info-server_item overview_component_server_id'>
                            <h3>Server ID</h3>
                            <p className='overview_component_server_server-id'>{overview?.guild_id}</p>
                        </div>
                        <div className='overview_component_info-server_item overview_component_server_subscription'>
                            <h3>Subscription Type</h3>
                            <p className='overview_component_server_premium'> 
                            <img src="/img/PremiumSub.svg" alt="" /> 
                            Premium</p>
                        </div>
                        <div className='overview_component_info-server_item overview_component_server_members'>
                            <h3>Members</h3>
                            <p className='overview_component_server_members_val'>
                                <img src="/img/Members.svg" alt="" /> 
                                {overview?.memberCount}
                            </p>
                        </div>
                    </div>
                    {/* <MyChartComponent/> */}
                    {/* useEffect(() => {
        if (valueSecurity >= 100) {
            setColorBg('#D8BE8D');
        } else if (valueSecurity >= 90) {
            setColorBg('#58B90A');
        } else if (valueSecurity >= 35) {
            setColorBg('#EF9D00');
        } else {
            setColorBg('#FF0F3C');
        }
    }, [valueSecurity]);  */}
                <div className='circle_block_range'>
                    {overview?.score <= 35 &&
                        <CircleRangeSlider
                            min={0}
                            max={100}
                            colorBg={'#FF0F3C'}
                            valueSecurity={overview?.score}
                            onChange={value => setSliderValue(value)}
                        />
                    }
                    {overview?.score > 35 && overview?.score <= 63 &&
                        <CircleRangeSlider
                            min={0}
                            max={100}
                            colorBg={'#EF9D00'}
                            valueSecurity={overview?.score}
                            onChange={value => setSliderValue(value)}
                        />
                    }
                    {overview?.score > 63 && overview?.score <= 99 &&
                        <CircleRangeSlider
                            min={0}
                            max={100}
                            colorBg={'#58B90A'}
                            valueSecurity={overview?.score}
                            onChange={value => setSliderValue(value)}
                        />
                    }
                    {overview?.score === 100 &&
                        <CircleRangeSlider
                            min={0}
                            max={100}
                            colorBg={'#D8BE8D'}
                            valueSecurity={overview?.score}
                            onChange={value => setSliderValue(value)}
                        />
                    }
                </div>
                </div>
            </div>
            <div className='overview_component_content'>
                <div className='overview_component_content_head'>
                    <h4>System Status</h4>
                    <p>Status of each feature and descrption</p>
                </div>
                <div className='overview_component_content_block overview_component_content_block_second'>
                    <div className='overview_component_system_status'>
                            {systemStatusArr.map((item, id) => (
                                <SystemStatusItem
                                    key={id}
                                    item={item}
                                    isActive={overview[item?.keyName]}
                                />
                            ))}
                    </div>
                    <div className='overview_component_system_quick_action'>
                        <h4>Quick Actions</h4>
                        <div className='overview_component_system_quick_action_item'>
                            <img src="" alt="" />
                            <p>Server Sandbox</p>
                            <TogglerBody/>
                        </div>
                        <div className='overview_component_system_quick_action_item'>
                            <img src="" alt="" />
                            <p>Themis Urgent Stop</p>
                            <TogglerBody/>
                        </div>
                        <div className='overview_component_system_quick_action_item'>
                            <img src="" alt="" />
                            <p>Report Critical Issue</p>
                            <TogglerBody/>
                        </div>
                    </div>
                </div>
            </div>
        { changesDetected && <ChangeDetectedItem cancel={cancelChanges} onSave={()=>handleSaveChanges(overviewApi.updateOverviewInfo, getOverview)} />}
        </div>
    );
};

export default OverviewComponent;